// Whether the user's active layers are currently drawn on the main map.
// true = visible (the default). See the eye toggle in
// src/component/main-ui/right-toolbar and the render consumers in
// src/component/map/render-layers and src/component/threedmap/render-3d-layer.

import {
  LAYERS_VISIBILITY_TOGGLE,
  LAYERS_VISIBILITY_SHOW,
} from '../action/layers-visible-actions'

const initialState = true

export default (state = initialState, action) => {
  switch (action.type) {
    case LAYERS_VISIBILITY_TOGGLE:
      return !state
    case LAYERS_VISIBILITY_SHOW:
    case 'LOGOUT':
      return initialState
    default:
      return state
  }
}
